import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { ROLES } from '@/lib/auth/roles'
import DateFilter from '@/lib/filters/date/date-filter'
import {isCurrentPage, validateSearchWithDefaults} from '@/lib/utils'
import ElevationByAdviser from '@/modules/elevation-by-adviser'
import { elevationByAdviserScoresQueryOptions } from '@/modules/elevation-by-adviser/hooks/hooks'
import ServiceTypeSelector from '@/modules/elevation-dashboard/components/service-type-selector'
import {
  ElevationByAdviserSearch, mergedElevationByAdviserSchema,
} from "@/types/route-search-schemas";
import { DataLoader } from '@/types/router-context'
import {ELEVATION_BY_ADVISER_PATH, ELEVATION_BY_ADVISER_URL} from '@/utils/urls'

export const Route = createFileRoute(ELEVATION_BY_ADVISER_PATH)(
  {
    component: ElevationAdviserScores,
    validateSearch: (search: Record<string, unknown>): ElevationByAdviserSearch => validateSearchWithDefaults(mergedElevationByAdviserSchema, search),

    loader: ({ context: { queryClient, date, serviceType, roles } }: DataLoader) => {
      if (isCurrentPage(ELEVATION_BY_ADVISER_URL)) {
        return
      }
      if (roles.includes(ROLES.ROLE_ELEVATION) && serviceType) {
        queryClient.prefetchQuery(elevationByAdviserScoresQueryOptions(date, serviceType))
      }
    },
    beforeLoad: () => {
      return {
        breadcrumbs: [
          { label: 'Adviser Performance', path: '#' },
          { label: 'Elevation performance', path: '/' }
        ],
        children: <>
          <ServiceTypeSelector />
          <DateFilter />
        </>
      }
    },
  },
)

function ElevationAdviserScores() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation
        roles={[ROLES.ROLE_ELEVATION]}
        permissions={[]}
        forbiddenFallback={<Unauthorized />}
      >
        <ElevationByAdviser />
      </Authorisation>
    </div>
  )
}
